/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { useOnClickOutside } from "../../../CommonMethods/OutsideClick";
import Button from "../../../components/Button";
import OrdersFilter from "./OrdersFilter";
import { useSelector } from "react-redux";

const OrdersTopBar = ({
    notFound,
    handleImport,
    isImport,
    branchUser,
    ApplyFilter,
    FilterData,
    AddButton,
    Tittle,
    SearchInput,
    AddButtonName,
    handleOnClickSearch,
    SearchValue,
    isClick,
    isFilter,
    FilterCheckbox,
    setFilterCheckBox,
    handleApplyFilter,
    filterCount,
    searchParams,
    BranchDisabled,
    createPath,
    handleFilters,
    handleExport,
    totaldata,
    tooltip,
    searchText,
    sidePane,
    handleSidePopupClick,
    handleSetDate,
    DateRange,
    SetDateRange,
    NoAction,
    testid,
    setsubmitSelected,
    setSearchParams,
    DateRangeError,
    SetDateRangeError,
    handleDatePickerValidation,
    DateErrorClear,
    productFilter,
    exportloading,
    importloading
}) => {
    const location = useNavigate();
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const outSideClick = useRef();
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const [timer, setTimer] = useState(null);
    const [search, setSearch] = useState(SearchValue);

    const initailState = {
        status: { Completed: false, Pending: false, Failed: false, Partial: false },
        paymentType: { 'Card Based Payment': false, 'Crypto Based Payment': false },
        dataRange: { create_start : '', create_end: '' },
        store: {store_email_address: '' , store : ''}
    }

    const [filterValues, setFilterValues] = useState(initailState)

    const handleSearch = (newValue) => {
        setSearch(newValue);
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            handleOnClickSearch("search", newValue)
        }, 500)
        setTimer(newTimer)
    }

    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false);
    });
    const [loading, setloading] = useState(false);

    const handleClick = async () => {
        setloading(true);
        await handleExport();
        setTimeout(() => {
            setloading(false);
        }, 1000);
    };
    const handleNavigation = () => {
        setsubmitSelected(false)
        if (createPath) {
            location(createPath)
        } else {
            sidePane(true);
            setEditData({})
        }
    }
    const handleSelectTabs = (key) => {
        let params = Object.fromEntries(searchParams);
        SetDateRange({
            create_start: '',
            create_end: '',
            update_start: '',
            update_end: ''
        })
        params = {}
        params.page_number = 1
        params.tab = key
        setSearchParams(params)
    }

    useEffect(() => {
        if (searchParams?.get('search') === null) {
            setSearch('')
        }
    }, [searchParams])

    const toggleSearch = () => {
        setIsSearchVisible(prevState => !prevState);
        const search = isSearchVisible
        // if (search) {
        //     handleSearch('');
        // }
    };

    useEffect(() => {
        let params = Object.fromEntries(searchParams);
        if(params.status){
            setFilterValues(prevState => {
                return updateFilterValueBasedOnInput(params?.status, prevState, 'status');
            })
        }
        if(params.payment_type){
            setFilterValues(prevState => {
                return updateFilterValueBasedOnInput(params?.payment_type, prevState, 'paymentType');
            })
        }
        if(params.store){
            setFilterValues(prevState => {
                return updateFilterValueBasedOnInput(params?.store_email_address, prevState, 'store');    
            })
        }
    },[])

    function updateFilterValueBasedOnInput(input, currentState, type) {
        // Split the input string by commas and convert it to an array
        const arr = input.split(',');
        
        // Create a copy of the current state
        const newState = { ...currentState };
        
        // Loop through the statuses array
        arr.forEach(value => {
          
            // Update the corresponding status property in the newState object
            newState[type][value] = true;
        });
      
        return newState;
    }

    const store = JSON.parse(localStorage.getItem('Store'));
    const { List } = useSelector(state => state.Orders);
    const param = Object.fromEntries(searchParams);


    return (
        <>
            <div className="bg-white flex pt-[10px] justify-between items-center px-8 pr-[66px]">
                <div className='pt-8 mb-8 flex justify-between items-center'>
                    <h1 className=' w-full breakword  text-xl font-medium font-playfair text-[#4B4B4B]'>Orders/Purchases List</h1>
                </div>
                {!loading && ((List?.data?.length >0 || (param.search || param.status || param.payment_type || param.create_start || param.create_end || param.store_email_address)) && !notFound  && <div className="flex justify-center items-center space-x-10">
                    <div className="relative">
                        <input
                            type="text"
                            value={search}
                            data-testid="search"
                            onChange={(e) => handleSearch(e.target.value)}
                            placeholder={searchText}
                            className={`w-[314px]  rounded-[8px] pr-10 pl-[14px] py-2 z-1 border border-[#8E8E8E] placeholder:text-sm placeholder:font-normal placeholder:text-[#1F1F1F] outline-none ${isSearchVisible ? 'block' : 'hidden'}`}
                        />
                        <img
                            src="/assets/images/search.svg"
                            alt=""
                            onClick={toggleSearch}
                            data-testid='search-btn'
                            className={`${isSearchVisible ? 'absolute top-[11px] right-[19px] cursor-pointer' : 'mr-[19px] mt-[-2px] cursor-pointer'} `}
                        />
                    </div>
                    {isFilter && <OrdersFilter
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        setIsFilterOpen={setIsFilterOpen}
                        isFilterOpen={isFilterOpen}
                        handleOnClickSearch={handleFilters}
                        handleSetDate={handleSetDate}
                        DateRange={DateRange}
                        handleApplyFilter={handleApplyFilter}
                        DateRangeError={DateRangeError}
                        SetDateRangeError={SetDateRangeError}
                        DateErrorClear={DateErrorClear}
                        handleDatePickerValidation={handleDatePickerValidation}
                        productFilter={productFilter}
                    />}
                    
                    <Button
                        classKey={`font-400 text-[14px] leading-[22px] px-[16px] py-[5px] border border-[#9E2064] text-primary rounded-[12px] relative`} // px-6 py-[8px] rounded-[16px]
                        text="Export"
                        disabled={loading}
                        type="button"
                        handleClick={handleExport}
                        testId="export-btn"
                        color="#9E2064"
                        loading={exportloading}
                        smallLoader={true}
                    />
                </div>)}
            </div>
        </>
    );
};

export default OrdersTopBar;
